import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonIcon,
} from '@ionic/react';
import {
    addCircle,
    chevronBack,
    chevronForward, download, downloadOutline,
} from 'ionicons/icons';
import useStore from "../../zustand/useStore";
import {
    actionToGetAdminContributionByFilter,
} from "../../apiHelpers/CommonAction";
import { FacebookLoader } from "../../components/Loader/FacebookLoader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ITEMS_PER_PAGE = 10;

export default function AdminContributePage() {
    const [currentPage, setCurrentPage] = useState(1);

    const { contributionDataState } = useStore();
    const { contributions, loading, totalCount } = contributionDataState;

    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);


    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetAdminContributionByFilter(false, { offset: newOffset });
    }, []);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const downloadExcel = () => {
        // ✅ 1. Sort by ID (ascending)
        const sortedData = [...contributions].sort((a, b) => a.id - b.id);

        // ✅ 2. Map only selected fields for Excel
        const formattedData = sortedData.map((item) => ({
            ID: item.id,
            Name: item.name,
            Email: item.email,
            Mobile: item.mobile,
            PAN: item.pan,
            Amount: item.amount,
            Status: item.payment_status,
            Currency: item.currency,
            'Razorpay Order ID': item.razorpay_order_id,
            'Razorpay Payment ID': item.razorpay_payment_id,
            'Member ID': item.member_id,
            'Created At': item.created_at,
            'Updated At': item.updated_at,
        }));

        // ✅ 3. Convert JSON → Worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // ✅ 4. Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

        // ✅ 5. Generate Excel & trigger download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(blob, "payments.xlsx");
    };

    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <h2 className="newsletter-heading">All Contributions</h2>
                        {contributions?.length > 0 ?
                            /*<IonIcon
                                className="add_news_icon"
                                onClick={() => downloadExcel()}
                                icon={download}
                            /> */
                            (
                                <button className="newsletter-heading_right download-button" onClick={() => downloadExcel()}>
                                    <IonIcon size={1} icon={downloadOutline}  />
                                    <span>Download</span>
                                </button>
                            ) :""
                        }
                    </div>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Member Id</th>
                                <th>Amount</th>
                                <th>Payment Status</th>
                                <th>Created At</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                <>
                                    {[...Array(2)].map((_, idx) => (
                                        <tr key={idx}>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                        </tr>
                                    ))}
                                </>
                            ) : contributions?.length > 0 ? (
                                contributions.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.name}</td>
                                        <td>{item.email}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.member_id}</td>
                                        <td>{item.amount}</td>
                                        <td>{item.payment_status}</td>
                                        <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '1rem' }}>
                                        No contributions found.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
}
